import { Component, HostBinding } from '@angular/core';
import { select } from '@angular-redux/store';
import { Observable } from 'rxjs';
import { ThemeOptions } from '../../../theme-options';
import { AuthenticateService } from '../../../shared/services/authenticate.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent {
  globalImgUrl: any;
  heading: string = '';

  constructor(public globals: ThemeOptions, private authService: AuthenticateService) {
  }

  @HostBinding('class.isActive')
  get isActiveAsGetter() {
    return this.isActive;
  }

  ngDoCheck() {
    if (!this.globalImgUrl) {
      this.globalImgUrl = this.authService.s3url();
    }
    this.authService.getHeading.subscribe((data) => {
      this.heading = data;
    })
  }

  isActive: boolean;

  @select('config') public config$: Observable<any>;

  toggleSidebarMobile() {
    this.globals.toggleSidebarMobile = !this.globals.toggleSidebarMobile;
  }

  toggleSidebar($event) {
    // this.showsidebar = !this.showsidebar;
    this.authService.hideandshowheader();
  }

  toggleHeaderMobile() {
    this.globals.toggleHeaderMobile = !this.globals.toggleHeaderMobile;
  }

}
